<template>
  <div>
    <div class="border-around">
      <vs-row>
        <EmailEditor
          ref="formEditor"
          v-on:load="editorLoaded"
          v-on:ready="editorReady"
          displayMode="web"
          min-height="800px"
          :options="options"
          :tools="tools"
          :projectId="projectId"
        />
      </vs-row>
    </div>
  </div>
</template>

<script>
import { EmailEditor } from "capacit-vue-dynamic-editor";

export default {
  components: {
    EmailEditor,
  },
  props: ["formJson", "legalDocuments", "interests"],
  data() {
    console.log("Interests", this.interests);
    return {
      appearance: {
        theme: "dark",
      },
      projectId: 61960,
      options: {
        version: "1.2.218",
        features: {
          smartMergeTags: false,
          textEditor: {
            tables: true,
          },
          preview: false,
        },
        customJS: [
          "https://rekomlifestorageprod.blob.core.windows.net/crm/consent.js", // For Consent webcomponent
          "https://rekomlifestorageprod.blob.core.windows.net/crm/unlayer_customjs.js", // For prod file
          // "http://localhost:8080/unlayer/unlayer_customjs.js", // For testing localhost
        ],
        customCSS: [
          `
          #u_body.u_body {
            min-height: auto !important;
          }
          .container {
            background-color: #eee;
          }
          `,
        ],
      },
      tools: {
        form: {
          enabled: false,
        },
        "custom#consent_tool": {
          enabled: true,
          position: 0,
          properties: {
            rekomType: {
              editor: {
                data: {
                  options: [
                    { label: "Consent", value: "consent" },
                    // { label: "Product", value: "product" },
                    { label: "Input", value: "input" },
                    { label: "Submit button", value: "submit" },
                  ],
                },
              },
            },
            input_name: {
              editor: {
                data: {
                  options: [
                    { label: "Select property", value: "" },
                    { label: "Guest first name", value: "firstName" },
                    { label: "Guest last name", value: "lastName" },
                    { label: "Guest birthdate", value: "birthDate" },
                    { label: "Guest email", value: "email" },
                    { label: "Guest phone", value: "phone" },
                    { label: "Guest interest", value: "interest" },

                    { label: "Number", value: "dynamic_form_number" },
                    { label: "Time", value: "dynamic_form_time" },
                    { label: "Text", value: "dynamic_form_text" },
                    { label: "Comments", value: "dynamic_form_comments" },
                    { label: "Choice", value: "dynamic_form_choice" },

                    // { label: "Arrival time", value: "arrivalTime" },
                    // { label: "Number of guests", value: "numGuests" },
                  ],
                },
              },
            },
            input_interest: {
              editor: {
                data: {
                  options: [
                    { label: "Select one", value: null },
                    ...this.interests.map(e => ({ label: e.name, value: e.name })),
                  ],
                },
              },
            },
            input_type: {
              editor: {
                data: {
                  options: [
                    { label: "Text", value: "text" },
                    { label: "Multiline text", value: "textarea" },
                    { label: "Select", value: "select" },
                    { label: "Email", value: "email" },
                    { label: "Number", value: "number" },
                    { label: "Date", value: "date" },
                    { label: "Time", value: "time" },
                    // { label: "Url", value: "url" },
                    // { label: "Checkbox", value: "checkbox" },
                    // { label: "Range", value: "range" },
                    // { label: "Color", value: "color" },
                  ],
                },
              },
            },
            consent_legalDoc: {
              editor: {
                data: {
                  options: [
                    { label: "Select one", value: null },
                    ...this.legalDocuments.map(e => ({ label: e.name, value: e.id })),
                  ],
                },
              },
            },
          },
        },
        "custom#venue_logo": {
          position: 1,
        },
      },
    };
  },

  methods: {
    applyMergeTags() {
      const venueTags = {};
      const handlebars = this.$store.getters["handlebars/getFor"]("venue");
      console.log("FormEditor: Handlebars", handlebars);
      handlebars.forEach(e => {
        venueTags[e.handlebar] = {
          name: e.name,
          value: `{{${e.handlebar}}}`,
          sample: e.sample,
        };
      });

      const tags = {
        venue: {
          name: "Venue",
          mergeTags: venueTags,
        },
      };

      this.$refs.formEditor.editor.setMergeTags(tags);
    },
    editorLoaded() {
      console.log("editorLoaded");
      if (this.formJson) this.$refs.formEditor.loadDesign(JSON.parse(this.formJson));

      // this.$refs.formEditor.editor.registerCallback("previewHtml", this.previewHtmlCallback);
      this.$refs.formEditor.editor.setBodyValues({
        backgroundColor: "rgba(0,0,0,0)",
      });
      this.applyMergeTags();
    },
    editorReady() {
      console.log("editorReady"); //editorReady not always called...
    },
    async saveDesign() {
      return new Promise(resolve => {
        this.$refs.formEditor.saveDesign(design => {
          console.log("saveDesign", design);
          resolve(design);
        });
      });
    },
    async export() {
      return new Promise(resolve => {
        this.$refs.formEditor.exportHtml(exportData => {
          console.log("exportHtml", exportData);

          resolve(exportData);
        });
      });
    },
  },
};
</script>

<style lang="scss">
.unlayer-editor {
  min-width: 100%;
}

.border-around {
  border: 1px #999 solid;
}
</style>